<script>
import { emojis } from "@/js/emojiList";
import { Emoji } from "emoji-mart-vue";

export default {
  components: {
    Emoji
  },
  props: ["message"],
  render(createElement) {
    let message = [];
    if (this.message.body) {
      message = this.message.body.split(":");
      message = message.map(part => {
        return emojis.includes(part) && message.length > 1
          ? createElement("emoji", { attrs: { emoji: `:${part}:` } })
          : part;
      });
      message = message.map((part, index) => {
        return index > 0 &&
          typeof part == "string" &&
          typeof message[index - 1] == "string"
          ? ":" + part
          : part;
      });
    } else {
      message = "";
    }
    return createElement("span", [message]);
  }
};
</script>
